import { Menu, ShoppingCart } from 'lucide-react';
import { navItems } from '../../data/homepageData';
import { Button } from '../ui/Button';
import { Logo } from '../ui/Logo';

export function SiteHeader() {
  return (
    <header className="site-header">
      <Logo />
      <nav className="site-nav" aria-label="Hlavní navigace">
        {navItems.map((item) => <a key={item.label} href={item.href}>{item.label}</a>)}
      </nav>
      <div className="site-header__actions">
        <a href="/projects" className="site-header__projects">Moje projekty</a>
        <Button href="/start" className="site-header__cta">Vytvořit kalendář</Button>
        <a className="cart-button" href="#footer" aria-label="Košík"><ShoppingCart size={18} /></a>
        <button className="mobile-menu" aria-label="Otevřít menu"><Menu size={24} /></button>
      </div>
    </header>
  );
}
